
import { defineComponent } from 'vue'
import { Table } from 'ant-design-vue'
import 'ant-design-vue/lib/table/style/css'

export default defineComponent({
    props: {
        tableHeight: {
            type: Number,
            value: 500
        },
        pagination: {
            type: Object,
            value: {}
        },
        dataList: {
            type: Array,
            value: []
        },
        columns: {
            type: Array,
            value: []
        },
        selectedRowKeys: {
            type: Array,
            value: []
        }
    },
    components: {
        Table
    },
    emits: ['tableChange', 'onSelectChange'],
    setup (_props, { emit }) {
        const onSelectChange = (value: any, selectRows) => {
            emit('onSelectChange', [value, selectRows]);
        }

        function handleChangeTable (pagination, filters, sorter) {
            emit('tableChange', { pagination, filters, sorter });
        }

        function handleTo (id) {
            window.location.hash = '/customers/' + id;
        }

        return {
            onSelectChange,
            handleChangeTable,
            handleTo
        }
    }
})
